// extracted by mini-css-extract-plugin
export default {"wrapper":"IeStatement_wrapper__7CMPR","count":"IeStatement_count__ntPhO","check":"IeStatement_check__B0GaS","sign-date":"IeStatement_sign-date__0xqeo"};